import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './genericNotificationPage.module.css';

interface GenericNotificationPageProps {
  title: string;
  subtitle?: string;
  iconUrl: string;
  button?: JSX.Element;
  errMsg?: string;
}

export const GenericNotificationPage = (
  props: GenericNotificationPageProps,
): JSX.Element => {
  return (
    <div className={styles.base}>
      <div className={styles.content}>
        <img
          src={props.iconUrl}
          className={styles.icon}
          style={
            isMobileOnly
              ? { width: '80%', height: 'unset', maxWidth: 400 }
              : undefined
          }
        />
        <div className={styles.titleBox}>
          <span
            className={styles.title}
            style={
              isMobileOnly
                ? {
                    fontWeight: 700,
                    fontSize: 22,
                  }
                : undefined
            }
          >
            {props.title}
          </span>
          {props.subtitle && (
            <span
              className={styles.subtitle}
              style={
                isMobileOnly ? { fontWeight: 400, fontSize: 17 } : undefined
              }
            >
              {props.subtitle}
            </span>
          )}
        </div>
        {props.button}
      </div>
      {props.errMsg && (
        <span className={styles.errMsg}>ERR: {props.errMsg}</span>
      )}
    </div>
  );
};
